// Görev Raporları sayfası kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'tasks.reports';

export const taskReportsGuide = (t: TFunction): GuideContent => ({
  layout: 'report',
  title: t(`${G}.title`, 'Görev Raporları nasıl kullanılır?'),
  intro: t(`${G}.intro`, 'Bir görevin ne zaman oluşturulduğunu, kabul edildiğini, başladığını ve tamamlandığını; tekrarlı görevlerde de her saatin yapılıp yapılmadığını bu ekrandan izlersiniz. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    filters: t(`${G}.regions.filters`, 'Görev Seçiniz'),
    actions: t(`${G}.regions.actions`, 'Excel / rapor indir'),
    totals: t(`${G}.regions.totals`, 'Rapor Detayları'),
    table: t(`${G}.regions.table`, 'Haftalık Görev Raporu'),
  },
  steps: [
    {
      region: 'filters',
      title: t(`${G}.s1.title`, '1. Görevi seçin'),
      text: t(`${G}.s1.text`, '"Görev Seçiniz" kutusuna görev adını yazın ("Görev Ara...") ve listeden seçin. Liste en son oluşturulan görev en üstte olacak şekilde sıralanır; her görevin yanında durumu (Beklemede, Kabul Edildi, Görev Başladı, Tamamlandı) görünür.'),
      tips: [
        t(`${G}.s1.tip1`, 'Şube müdürü olarak girdiyseniz listede yalnız kendi şubenizin personeline atanmış görevler ve kimseye atanmamış görevler bulunur.'),
      ],
    },
    {
      region: 'totals',
      title: t(`${G}.s2.title`, '2. Tek seferlik görevin raporu'),
      text: t(`${G}.s2.text`, 'Tekrarsız görevde "Görev Tarihleri" (Oluşturulma ve Kabul Edilme Tarihi), "Görev Durumu" (Beklemede → Başladı → Tamamlandı) ve "Toplam Görev Süresi" gösterilir. Süre, görevin başladığı andan tamamlandığı ana kadar hesaplanır; görev henüz bitmediyse şu ana kadar geçen süre gösterilir, hiç başlamadıysa süre hesaplanmaz.'),
      tips: [
        t(`${G}.s2.tip1`, '"Görev Atanan Personel" bölümünde görevin verildiği kişinin adı ve e-postası görünür.'),
      ],
    },
    {
      region: 'table',
      title: t(`${G}.s3.title`, '3. Tekrarlı görevde haftalık tablo'),
      text: t(`${G}.s3.text`, 'Tekrarlı görevde "Haftalık Görev Raporu" tablosu son 7 günü (bugün en altta, çerçeveli) ve görevin ayarlı saatlerini gösterir. Yeşil tik: o saatteki görev tamamlandı. Kırmızı X: yapılmadı. Turuncu, kırmızı çerçeveli daire: başlatıldı ama tamamlanmadı. Boş hücre: kayıt yok.'),
      tips: [
        t(`${G}.s3.tip1`, 'Tablo dar ekranda sağa-sola kaydırılır. Göreve saat ayarlanmamışsa "Bu görev için ayarlanmış saat bulunamadı" yazar.'),
      ],
    },
    {
      region: 'actions',
      title: t(`${G}.s4.title`, '4. Raporu Excel\'e indirin'),
      text: t(`${G}.s4.text`, 'Görev seçilince sağ üstte "Excel İndir" düğmesi çıkar: tekrarlı görevde ekrandaki 7 günlük tabloyu, tek seferlik görevde görev bilgilerini ve süreyi dosyaya aktarır.'),
      tips: [
        t(`${G}.s4.tip1`, 'Tekrarlı görevlerde ayrıca "1 Aylık Rapor İndir" (bugünden geriye son bir ay) ve "İki Tarih Arası Rapor İndir" düğmeleri vardır. İkincisinde açılan pencerede Başlangıç Tarihi ve Bitiş Tarihi seçip "İndir"e basın.'),
      ],
    },
  ],
});
